import { useContext } from "react";
import { DateRangeContext, DateRangeContextType } from "../../contexts/DateRangeContextDefinition";

export const useDateRange = (): DateRangeContextType => {
  const context = useContext(DateRangeContext);
  if (!context) {
    throw new Error("useDateRange must be used within a DateRangeProvider");
  }
  return context;
};
